import moment from 'moment-timezone';

import { Event } from '../interfaces';
import { hourToString } from './describeHoursRange';

const dayIntToStringMapShortForm = new Map<number, string>([
  [0, moment().day(0).format('dd')],
  [1, moment().day(1).format('dd')],
  [2, moment().day(2).format('dd')],
  [3, moment().day(3).format('dd')],
  [4, moment().day(4).format('dd')],
  [5, moment().day(5).format('dd')],
  [6, moment().day(6).format('dd')],
]);

const dayIntToStringMapLongForm = new Map<number, string>([
  [0, moment().day(0).format('dddd')],
  [1, moment().day(1).format('dddd')],
  [2, moment().day(2).format('dddd')],
  [3, moment().day(3).format('dddd')],
  [4, moment().day(4).format('dddd')],
  [5, moment().day(5).format('dddd')],
  [6, moment().day(6).format('dddd')],
]);

export const withinEnforcementTime = (event: Event) => {
  const inEnforceTime = event?.within_enforce_time;
  if (inEnforceTime != null) {
    return inEnforceTime ? 'Yes' : 'No';
  }
  return 'unspecified';
};

export const getEnforcementPeriods = (event: Event, shortForm = true): string[] => {
  const enforcementDetailsForBlockFiltered =
    event?.metadata?.route_metadata?.enforcement_info?.filter((ei) => ei.event_types?.includes(event?.event_type_identifier)) || [];

  const filteredSource =
    enforcementDetailsForBlockFiltered.length === 0 ? [event?.metadata?.route_metadata] : enforcementDetailsForBlockFiltered;

  const periodsArray = [] as string[];

  const dayIntToStringMap = shortForm ? dayIntToStringMapShortForm : dayIntToStringMapLongForm;

  for (let i = 0; i < filteredSource?.length; i++) {
    const enforcementDaysArray = filteredSource[i]?.enforce_days || [];
    const enforceTimeStart = filteredSource[i]?.enforce_start;
    const enforceTimeEnd = filteredSource[i]?.enforce_end;

    const enforce2TimeStart = filteredSource[i]?.enforce2_start ?? 0;
    const enforce2TimeEnd = filteredSource[i]?.enforce2_end ?? 24;

    if (enforcementDaysArray.length === 0 && filteredSource.length === 1) {
      periodsArray.push('Skip');
      return periodsArray;
    }

    if (enforceTimeStart === 0 && enforceTimeEnd === 24 && filteredSource.length === 1) {
      periodsArray.push('24h');
      return periodsArray;
    }

    if (!enforceTimeStart && !enforceTimeEnd && filteredSource.length === 1) {
      periodsArray.push('None');
      return periodsArray;
    }
    // sort to ensure 0 -> 6 order
    enforcementDaysArray.sort();
    let enforcementDays = '';
    if (enforcementDaysArray.length === 1) {
      const dayString = dayIntToStringMap.get(enforcementDaysArray[0]);
      return dayString ? [dayString] : [];
    }
    let isChain = false;
    for (let j = 0; j <= enforcementDaysArray.length - 1; j++) {
      if (j === enforcementDaysArray.length - 1) {
        enforcementDays = `${enforcementDays} ${dayIntToStringMap.get(enforcementDaysArray[j])}`;
      }
      if (isChain) {
        if (enforcementDaysArray[j + 1] - enforcementDaysArray[j] > 1) {
          isChain = false;
        }
      }
      if (!isChain) {
        enforcementDays += dayIntToStringMap.get(enforcementDaysArray[j]);
        if (enforcementDaysArray[j + 1] - enforcementDaysArray[j] === 1) {
          enforcementDays += ' - ';
          isChain = true;
        } else {
          enforcementDays += ', ';
          isChain = false;
        }
      }
    }

    let secondEnforceTime = '';
    if (enforce2TimeStart && enforce2TimeEnd) {
      secondEnforceTime = ` and ${hourToString(enforce2TimeStart)} - ${hourToString(enforce2TimeEnd)}`;
    }

    periodsArray.push(`${enforcementDays}, ${hourToString(enforceTimeStart)} - ${hourToString(enforceTimeEnd)}${secondEnforceTime}`);

    // loop ends here
  }
  return periodsArray;
};

export const isInEnforcementZone = (event: Event) => {
  return event?.within_enforce_zone ? 'Yes' : 'No';
};
